import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: [],
  reducers: {
    setNotifications: (state, action) => action.payload,
    addNotification: (state, action) => {
      state.push(action.payload);
    },
    markAsRead: (state, action) => {
      const index = state.findIndex((n) => n.id === action.payload);
      if (index >= 0) state[index].read = true;
    },
  },
});

export const { setNotifications, addNotification, markAsRead } =
  notificationSlice.actions;
export default notificationSlice.reducer;
